// @note needs to be synced with the backend BookingPaymentTimingEnum

const bookingPaymentTimingEnum = [
  {
    label: 'Alleen Vooraf',
    value: 'before',
  },
  {
    label: 'Achteraf betalen',
    value: 'after',
  },
];

bookingPaymentTimingEnum.getLabel = function (value) {
  return this.find(option => option.value === value)?.label ?? '';
};

export default bookingPaymentTimingEnum

